import classNames from "classnames/dedupe";
import React, { FC, ReactNode } from "react";

import { BackSmallBlueIcon, NextIcon } from "../../../../icons";
import { ILink, Link } from "../../../ActionsSelectors/Link";
import { TabLink } from "../../../Utility/TabSwitcher";

export interface IMenuTabProps extends ILink {
  /**
   * Set tab ID for inner `TabLink` component.
   */
  tabDisplayId?: string;

  /**
   * Change a visual representation of component
   */
  variant?:
    | "default"
    | "back-navigation"
    | "back-navigation-light"
    | "light"
    | "medium";

  /**
   * Set if item should be rendered with arrow icon
   */
  withIcon?: boolean;
  children?: ReactNode;
}

const MobileNavItem: FC<IMenuTabProps> = ({
  tabDisplayId,
  variant = "default",
  children,
  withIcon,
  ...link
}) => {
  const tabStyle = classNames({
    "mobile-nav-item": variant === "default",
    "mobile-nav-item mobile-nav-item--light": variant === "light",
    "mobile-nav-item mobile-nav-item--medium": variant === "medium",
    "mobile-back-link": variant === "back-navigation",
    "mobile-back-link mobile-back-link--light":
      variant === "back-navigation-light",
  });

  const tabLink = (
    <TabLink tabDisplayId={tabDisplayId?.toLowerCase()}>
      <Link classes={{ root: tabStyle }} {...link}>
        <>
          {(variant === "back-navigation" ||
            variant === "back-navigation-light") && <BackSmallBlueIcon />}
          {children}
          {withIcon && <NextIcon />}
        </>
      </Link>
    </TabLink>
  );

  return variant === "back-navigation" ||
    variant === "back-navigation-light" ? (
    tabLink
  ) : (
    <li className="mobile-nav-link">{tabLink}</li>
  );
};

export default MobileNavItem;
